/* @flow */
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import React from 'react';

import cx from 'classnames';
import './styles/LoadingIndicator.scss';

class LoadingIndicator extends React.Component {
  static propTypes = {
    align: React.PropTypes.oneOf(['left', 'center', 'right']),
    size: React.PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
    color: React.PropTypes.oneOf(['eclipse', 'lava', 'white', 'rain']),
    /** Placehold height for content to be loaded */
    height: React.PropTypes.oneOf([400]),
  };

  static propClasses = {
    align: {
      left: 'LoadingIndicator--left',
      center: 'LoadingIndicator--center',
      right: 'LoadingIndicator--right',
    },
    size: {
      xsmall: 'LoadingIndicator-sizexSmall',
      small: 'LoadingIndicator-sizeSmall',
      medium: 'LoadingIndicator-sizeMedium',
      large: 'LoadingIndicator-sizeLarge',
    },
    color: {
      eclipse: 'LoadingIndicator-eclipse',
      white: 'LoadingIndicator-white',
      lava: 'LoadingIndicator-lava',
      rain: 'LoadingIndicator-rain',
    },
    height: {
      /* eslint-disable quote-props */
      '400': 'LoadingIndicator--height400',
      /* eslint-enable quote-props */
    },
  };

  static defaultProps = {
    size: 'medium',
    color: 'eclipse',
  };

  render() {
    return (
      <div
        {...this.props}
        height={this.props.height}
        className={cx(
          'LoadingIndicator',
          { 'LoadingIndicator--height': this.props.height },
          getPropClassesFromInstance(this),
          this.props.className,
        )}>
        <div className="LoadingIndicator-bounce1" />
        <div className="LoadingIndicator-bounce2" />
        <div className="LoadingIndicator-bounce3" />
      </div>
    );
  }
}

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator.jsx